import { path } from 'ramda'
import base from './base'

const config = {
  ...base,
  // ...require(`./${process.env.REACT_APP_API_CONFIG || process.env.NODE_ENV}`).default,
}

export default (key: string) => {
  if (key) {
    const result = path(key.split('.'), config)
    return result
  }

  return config
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config/index.ts